module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_9016.d373d0a5.png";